"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setCookie(name, value) {
    document.cookie = name + "=" + value;
}
exports.setCookie = setCookie;
function hasCookie(name) {
    return document.cookie
        .split(';')
        .some(function (item) { return item.trim().startsWith(name + "="); });
}
exports.hasCookie = hasCookie;
function removeCookie(name) {
    if (hasCookie(name)) {
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    }
}
exports.removeCookie = removeCookie;
//# sourceMappingURL=cookie.js.map